import React from 'react';
import styled from '@emotion/styled';
import Textfield from '@atlaskit/textfield';
import { Currency } from '@css-xp/graphtypes';

interface Props {
  setSelectedPONumber: (poNumber: string) => void;
  defaultPONumber?: string | null;
}

const StyledPONumberTextFieldLabel = styled.label({
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '16px',
  textAlign: 'left',
  color: '#44546F',
});

export const ChangePONumber = ({ setSelectedPONumber, defaultPONumber }: Props) => {
  return (
    <>
      <div data-testid="currency-field">
        <StyledPONumberTextFieldLabel>Currency</StyledPONumberTextFieldLabel>
        <Textfield isDisabled={true} name="currency" testId="currency-usd" defaultValue={Currency.USD} />
      </div>
      <div data-testid="purchase-order-field">
        <StyledPONumberTextFieldLabel>PO number</StyledPONumberTextFieldLabel>
        <Textfield
          name="purchaseOrderNumber"
          testId="purchase-order-number"
          onChange={(event) => setSelectedPONumber(event.currentTarget.value)}
          placeholder="Enter PO number"
          defaultValue={defaultPONumber || ''}
        />
      </div>
    </>
  );
};
